module.exports = "<react-component name=\"{{component}}\" props=\"props\"></react-component>\n";